export default {"src":"/_next/static/media/earn-step-2.d651f32f.svg","height":806,"width":1050,"blurWidth":0,"blurHeight":0};